<template>
  <div v-if="lock" class="lockScreen"></div>
</template>

<script>
import * as StoreUtil from "../../util/StoreUtil";
export default {
  name: "Lock",
  data() {
    return {
      timer: null
    };
  },
  computed: {
    lock() {
      return this.$store.state.lock.lock;
    }
  },
  watch: {
    lock(val) {
      if (val) {
        this.unlockTimer();
      }
      else {
        this.killTimer();
      }
    }
  },
  methods: {
    unlockTimer() {
      this.killTimer();
      this.timer = setTimeout(() => {
        StoreUtil.lock(false);
      }, 500);
    },
    killTimer() {
      if (this.timer) clearTimeout(this.timer);
      this.timer = null;
    }


  }
};
</script>

<style scoped lang="sass">
@import "../../sass/common"
@import "../../sass/zindex"
div.lockScreen
    position: fixed
    z-index: $z_lock
    @include fit()
    //background-color: rgba(0, 0, 0, 0.8)
</style>
